import { Link } from "wouter";
import logo from "@/assets/select_cleaning_logo.png";

export default function Footer() {
    return (
        <footer className="bg-gray-50 text-gray-600 py-16 border-t border-gray-100" role="contentinfo">
            <div className="container mx-auto px-4 grid md:grid-cols-4 gap-12">
                <div>
                    <img src={logo} alt="Select Cleaning — Professional cleaning services in Auckland, New Zealand" className="w-64 h-auto mb-6" width="256" height="32" loading="lazy" />
                    <p className="text-sm text-gray-700 leading-relaxed">
                        Auckland's trusted professional cleaning company. Security-checked cleaners providing residential and commercial cleaning services across all Auckland suburbs.
                    </p>
                </div>

                <nav aria-label="Services navigation">
                    <h3 className="font-bold text-gray-900 mb-6">Our Services</h3>
                    <ul className="space-y-4 text-sm">
                        <li><Link href="/residential"><a className="hover:text-primary transition-colors" title="Professional home cleaning across Auckland">Residential House Cleaning</a></Link></li>
                        <li><Link href="/commercial"><a className="hover:text-primary transition-colors" title="Office and workplace cleaning in Auckland">Commercial Office Cleaning</a></Link></li>
                        <li><Link href="/franchise"><a className="hover:text-primary transition-colors" title="Buy a cleaning franchise business in Auckland">Cleaning Franchise Opportunities</a></Link></li>
                    </ul>
                </nav>

                <div itemScope itemType="https://schema.org/LocalBusiness">
                    <meta itemProp="name" content="Select Cleaning" />
                    <h3 className="font-bold text-gray-900 mb-6">Contact Us</h3>
                    <ul className="space-y-4 text-sm">
                        <li>
                            <a href="tel:0800223315" className="flex items-center gap-2 hover:text-primary transition-colors" itemProp="telephone">
                                <span className="font-semibold text-primary">0800 22 33 15</span>
                            </a>
                        </li>
                        <li>
                            <a href="mailto:ajay.l@select.biz" className="hover:text-primary transition-colors" itemProp="email">ajay.l@select.biz</a>
                        </li>
                        <li itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                            <span itemProp="addressLocality">Auckland</span>, <span itemProp="addressCountry">New Zealand</span>
                        </li>
                    </ul>
                </div>

                <nav aria-label="Legal navigation">
                    <h3 className="font-bold text-gray-900 mb-6">Legal</h3>
                    <ul className="space-y-4 text-sm">
                        <li><Link href="/privacy-policy"><a className="hover:text-primary transition-colors" title="Select Cleaning privacy policy">Privacy Policy</a></Link></li>
                    </ul>
                </nav>
            </div>
            <div className="container mx-auto px-4 mt-12 pt-8 border-t border-gray-200 text-center text-xs text-gray-600">
                <p>© {new Date().getFullYear()} Select Cleaning. All rights reserved. Professional cleaning services in Auckland, New Zealand.</p>
            </div>
        </footer>
    );
}
